/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit LocationChoice/view.blocks to change it.
import "DesignSystem/Fonts/Inter-400.css"
import "DesignSystem/Fonts/Inter-600.css"
import * as fromFlow from 'Simple/Flow'
import ButtonVisitChoice from 'DesignSystem/ButtonVisitChoice/index'
import LocationMarker from 'DesignSystem/Svgs/LocationMarker/index'
import React from 'react'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'
import useIsMedia from 'Simple/hooks/useIsMedia'



/** @type {import('Simple/types.js').View} */
export default function LocationChoice({
  children,
  viewPath = "/DesignSystem/LocationChoice",
  onMouseEnter,
  onMouseLeave,
  borderBottomLeftRadius = 6,
  borderBottomRightRadius = 6,
  borderTopLeftRadius = 6,
  borderTopRightRadius = 6,
  onClick,
  innerRef,
  isSelected,
  isHighlighted,
  locationName = "",
  text = "Little Rock, AR",
  subtext = "401 Rocky Street",
  hasDistance,
  distance = "10m",
  hasVirtual,
  onSelect,
  id,
  selected,
  selectedLocationVisitType,
  parentViewPath,
  hasInPerson
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({onMouseEnter,onMouseLeave,isSelected})
  let isMedia = useIsMedia()
  return (<React.Fragment
>
<div
  data-testid="LocationChoice.Vertical"
  data-view-path={viewPath}
 onMouseEnter={onMouseEnter}
 onMouseLeave={onMouseLeave}
 className="views-block"
>
<button
  data-testid="LocationChoice.Vertical:1"
  data-view-path={viewPath}
 {...isHoveredBind}
 onClick={onClick}
 ref={innerRef}
 style={{'--bblr-2-Z1XWmtx': typeof borderBottomLeftRadius === 'number' ? `${borderBottomLeftRadius}px` : borderBottomLeftRadius,'--bbrr-3-Z1XWmtx': typeof borderBottomRightRadius === 'number' ? `${borderBottomRightRadius}px` : borderBottomRightRadius,'--btlr-5-Z1XWmtx': typeof borderTopLeftRadius === 'number' ? `${borderTopLeftRadius}px` : borderTopLeftRadius,'--btrr-6-Z1XWmtx': typeof borderTopRightRadius === 'number' ? `${borderTopRightRadius}px` : borderTopRightRadius,'--bc-1-Z1XWmtx': isSelected ? "rgba(0,147,201, 0.3)" : isHovered ? "rgba(0,147,201, 0.05)" : isHighlighted ? "rgba(0,147,201, 0.05)" : "#ffffff",'--bc-4-Z1XWmtx': isSelected ? "#0093c9" : isHovered ? "rgba(0,147,201, 0.83)" : isHighlighted ? "rgba(0,147,201, 0.83)" : "#ebebeb",'--h-9-Z1XWmtx': isMedia.mobile ? "130px" : "auto",'--w-8-Z1XWmtx': isMedia.mobile ? "230px" : "200px",'--mr-7-Z1XWmtx': isMedia.mobile ? "5px" : "0px"}}
 className={`views-block ${styles.Vertical}`}
>
<span
  data-testid="LocationChoice.Text"
  data-view-path={viewPath}
 style={{'--c-10-Z1XWmtx': isSelected ? "#0093c9" : isHovered ? "rgba(0,147,201, 1)" : isHighlighted ? "#0093c9" : "#404040"}}
 className={`views-text ${styles.Text}`}
>
{locationName}
</span>
<span
  data-testid="LocationChoice.Text:1"
  data-view-path={viewPath}
 style={{'--c-10-Z1XWmtx': isSelected ? "#0093c9" : isHovered ? "rgba(0,147,201, 1)" : isHighlighted ? "#0093c9" : "#404040"}}
 className={`views-text ${styles.Text1}`}
>
{text}
</span>
<span
  data-testid="LocationChoice.Subtext"
  data-view-path={viewPath}
 style={{'--c-10-Z1XWmtx': isSelected ? "#0093c9" : isHovered ? "rgba(0,147,201, 1)" : isHighlighted ? "#0093c9" : "#404040"}}
 className={`views-text ${styles.Subtext}`}
>
{subtext}
</span>
<div
  data-testid="LocationChoice.Horizontal"
  data-view-path={viewPath}
 style={{'--jc-11-Z1XWmtx': hasDistance ? "space-between" : "flex-end"}}
 className={`views-block ${styles.Horizontal}`}
>
<fromFlow.When is={hasDistance}>
<div
  data-testid="LocationChoice.Distance"
  data-view-path={viewPath}
 className={`views-block ${styles.Distance}`}
>
<LocationMarker
  viewPath={`${viewPath}/LocationMarker`}
 width={12}
 height={12}
 fill="#161616"
/>
<span
  data-testid="LocationChoice.Text:2"
  data-view-path={viewPath}
 style={{'--c-10-Z1XWmtx': isSelected ? "#0093c9" : isHovered ? "#0093c9" : isHighlighted ? "#0093c9" : "#161616"}}
 className={`views-text ${styles.Text2}`}
>
{distance}
</span>
</div>
</fromFlow.When>
</div>
<div
  data-testid="LocationChoice.Horizontal:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal1}`}
>
<fromFlow.When is={hasVirtual}>
<div
  data-testid="LocationChoice.Vertical:2"
  data-view-path={viewPath}
 style={{'--o-12-Z1XWmtx': isSelected ? 1 : isHovered ? 1 : isHighlighted ? 1 : isMedia.mobile ? 1 : 0,'--pe-13-Z1XWmtx': isSelected ? "auto" : isHovered ? "auto" : isHighlighted ? "auto" : isMedia.mobile ? "auto" : "auto"}}
 className={`views-block ${styles.Vertical1}`}
>
<ButtonVisitChoice
  viewPath={`${viewPath}/ButtonVisitChoice`}
 borderColor="rgba(0,147,201, 0.83)"
 marginTop={0}
 width="auto"
 onClick={onSelect}
 id={id}
 locationVisitType="virtual"
 selected={selected}
 selectedLocationVisitType={selectedLocationVisitType}
 parentViewPath={parentViewPath}
 text="Virtual Visit"
/>
</div>
</fromFlow.When>
<fromFlow.When is={hasInPerson}>
<div
  data-testid="LocationChoice.Vertical:3"
  data-view-path={viewPath}
 style={{'--o-12-Z1XWmtx': isSelected ? 1 : isHovered ? 1 : isHighlighted ? 1 : isMedia.mobile ? 1 : 0,'--pe-13-Z1XWmtx': isSelected ? "auto" : isHovered ? "auto" : isHighlighted ? "auto" : isMedia.mobile ? "auto" : "auto"}}
 className={`views-block ${styles.Vertical2}`}
>
<ButtonVisitChoice
  viewPath={`${viewPath}/ButtonVisitChoice`}
 borderColor="rgba(0,147,201, 0.83)"
 width="auto"
 marginTop={0}
 marginLeft={4}
 onClick={onSelect}
 id={id}
 locationVisitType="inPerson"
 selected={selected}
 selectedLocationVisitType={selectedLocationVisitType}
 parentViewPath={parentViewPath}
 text="In Person"
/>
</div>
</fromFlow.When>
</div>
</button>
</div>
{children}
</React.Fragment>)
}